import {pick} from 'lodash-es';
import {screens} from '@/config/tailwind';

export const useCurrentBreakpoint = (): ComputedRef<keyof typeof screens | undefined> => {
	const breakpoints = pick(useTailwindBreakpoints(), Object.keys(screens)) as Record<keyof typeof screens, Ref<boolean>>;
	return computed(() => {
		return Object
			.keys(screens)
			.reverse()
			.find((breakpoint) => breakpoints[breakpoint as keyof typeof screens].value) as keyof typeof screens | undefined;
	});
};
